// ** React Imports
import { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

// ** Redux Imports
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";

// ** Toast
import { Toaster } from "react-hot-toast";

// ** Core styles
import "./index.css";
import { initSentry } from "./services/sentryService";

initSentry()
// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense>
          <LazyApp />
          <Toaster />
        </Suspense>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
